import { useEncryption as useEncryptionContext } from '@/context/EncryptionContext'

// Re-export the hook from context
export const useEncryption = useEncryptionContext
